import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/wap/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-55ff474a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"6rem","height":"8rem"},
  src: _imports_0,
  alt: "GEP Group"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex-grow":"10"} }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1))

import { ref } from 'vue'
  import { useRoute, useRouter } from 'vue-router';
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'Menu-wap',
  setup(__props) {

  const route = useRoute();
  const router = useRouter();
  
  const backToHome = () => {
    router.push('/home');
  }
  
  const handleSelect = (key: string, keyPath: string[]) => {
    
  }

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createBlock(_component_el_menu, {
    router: "",
    "default-active": _unref(route).path,
    class: "el-menu-demo menu-with-shadow",
    mode: "horizontal",
    "background-color": "#232946",
    "text-color": "#fffffe",
    "active-text-color": "#eebbc3",
    ellipsis: false,
    onSelect: handleSelect,
    style: {"height":"6rem"},
    "menu-trigger": "click",
    "close-on-click-outside": true
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_el_menu_item, { onClick: backToHome }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _hoisted_3,
      _createVNode(_component_el_sub_menu, {
        index: "3",
        "popper-class": "selectStyle",
        id: "one"
      }, {
        title: _withCtx(() => [
          _createTextVNode("Services")
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_menu_item, { index: "/about-wap" }, {
            default: _withCtx(() => [
              _createTextVNode("About")
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "/education-wap" }, {
            default: _withCtx(() => [
              _createTextVNode("Education")
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "/training-wap" }, {
            default: _withCtx(() => [
              _createTextVNode("Training")
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "/employment-wap" }, {
            default: _withCtx(() => [
              _createTextVNode("Employment")
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "/contact-wap" }, {
            default: _withCtx(() => [
              _createTextVNode("Contact")
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "/staff-wap" }, {
            default: _withCtx(() => [
              _createTextVNode("Staff Portal")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _hoisted_4
    ]),
    _: 1
  }, 8, ["default-active"]))
}
}

})